import { ReactNode } from "react";
import { AnimatedFontProperty } from "../widgetproperties/AnimatedFontProperty";
import { BooleanProperty } from "../widgetproperties/BooleanProperty";
import { BorderProperty } from "../widgetproperties/BorderProperty";
import { TextProperty } from "../widgetproperties/TextProperty";
import { AbstractWidgetSettings } from "./AbstractWidgetSettings";
import classes from "./AbstractWidgetSettings.module.css";
import {
  ColorProperty,
  ColorPropertyTarget,
} from "../widgetproperties/ColorProperty";
import { RoundingProperty } from "../widgetproperties/RoundingProperty";
import { PaddingProperty } from "../widgetproperties/PaddingProperty";
import { BlurProperty } from "../widgetproperties/BlurProperty";
import { BoxShadowProperty } from "../widgetproperties/BoxShadowProperty";
import { DonationTimer } from "../../../pages/DonationTimer/DonationTimer";
import { DemoHistoryStore } from "../../../stores/history";
import { Flex } from "antd";
import { CloseOverlayButton } from "../../Overlay/Overlay";
import { AlignmentProperty } from "../widgetproperties/AlignmentProperty";

export class DonationTimerWidgetSettings extends AbstractWidgetSettings {
  constructor() {
    super({ sections: [] });

    this.addSection({
      key: "general",
      title: "Общие",
      properties: [
        new BooleanProperty({
          name: "resetOnLoad",
          value: true,
          displayName: "widget-donation-timer-refresh",
        }),
        new TextProperty({
          name: "text",
          value: "Без донатов уже <time>",
          displayName: "widget-donation-timer-text",
        }),
        new AnimatedFontProperty({
          name: "titleFont",
        }),
      ],
    });

    this.addSection({
      key: "style",
      title: "Стиль",
      properties: [
        new AlignmentProperty({
          name: "textAlign",
          displayName: "text-alignment",
        }),
        new ColorProperty({
          name: "backgroundColor",
          displayName: "background-color",
          target: ColorPropertyTarget.BACKGROUND,
          value: {
            angle: 0,
            colors: [
              {
                color: "rgba(0, 0, 0, 0)",
              },
            ],
            gradient: false,
            repeating: false,
            gradientType: 0,
          },
        }),
        new BorderProperty({
          name: "border",
        }),
        new RoundingProperty({
          name: "rounding",
        }),
        new PaddingProperty({
          name: "padding",
        }),
        new BoxShadowProperty({
          name: "boxShadow",
          displayName: "Тени виджета",
          help: "Устанавливает тени виджета.",
        }),
      ],
    });
  }

  public get boxShadowProperty(): BoxShadowProperty {
    return (
      (this.get("boxShadow") as BoxShadowProperty) ||
      new BoxShadowProperty({
        name: "boxShadow",
        displayName: "Тени виджета",
        help: "Устанавливает тени виджета.",
      })
    );
  }

  public get textAlign(): AlignmentProperty {
    return this.get("textAlign") as AlignmentProperty;
  }

  public get blurProperty(): BlurProperty {
    return (
      (this.get("blur") as BlurProperty) || new BlurProperty({ name: "blur" })
    );
  }

  public get textProperty(): string {
    return this.get("text")?.value || "Стрим будет идти еще <time>";
  }

  public get titleFontProperty(): AnimatedFontProperty {
    return (
      (this.get("titleFont") as AnimatedFontProperty) ||
      new AnimatedFontProperty({
        name: "titleFont",
      })
    );
  }

  public get backgroundColorProperty(): ColorProperty {
    return (
      (this.get("backgroundColor") as ColorProperty) ||
      new ColorProperty({
        name: "backgroundColor",
        displayName: "background-color",
        target: ColorPropertyTarget.BACKGROUND,
      })
    );
  }

  public get borderProperty(): BorderProperty {
    return (
      (this.get("border") as BorderProperty) ||
      new BorderProperty({ name: "border" })
    );
  }

  public get paddingProperty(): PaddingProperty {
    return (
      (this.get("padding") as PaddingProperty) ||
      new PaddingProperty({
        name: "padding",
      })
    );
  }

  public get roundingProperty(): RoundingProperty {
    return (
      (this.get("rounding") as RoundingProperty) ||
      new RoundingProperty({ name: "rounding" })
    );
  }

  public get resetOnLoad(): boolean {
    const resetOnLoad =
      this.get("resetOnLoad") ??
      new BooleanProperty({
        name: "resetOnLoad",
        value: true,
        displayName: "widget-donation-timer-refresh",
      });
    return resetOnLoad.value;
  }

  public help(): ReactNode {
    return (
      <>
        <Flex align="top" justify="space-between">
          <h3 className={`${classes.helptitle}`}>Виджет "Таймер донатов"</h3>
          <CloseOverlayButton />
        </Flex>
        <div className={`${classes.helpdescription}`}>
          Считает время с момента последнего доната, обновляется автоматически
          реал-тайм.
        </div>
        <h3 className={`${classes.helptitle}`}>Как подключить</h3>
        <div className={`${classes.helpdescription}`}>
          <ul>
            <li>В меню этого виджета (Таймер донатов) скопировать ссылку.</li>
            <li>
              Вставить ссылку как Browser Source в OBS поверх картинки стрима.
            </li>
          </ul>
        </div>
      </>
    );
  }

  public hasDemo() {
    return true;
  }

  public demo() {
    return <DonationTimer settings={this} store={new DemoHistoryStore()} />;
  }
}
